document.addEventListener('click', function(e) {
    const btn = e.target.closest('.beae-custom-atc');

    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const form = e.target.closest('.beae-product-form-next');

    handleLoadingButton(form, true);

    let formData = new FormData(form);
    if (!formData.has('id')) {
        formData.append('id', form.getAttribute('data-variant-id'));
    }
    const currentSections = formData.get('sections') || '';
    const sectionsArray = currentSections ? currentSections.split(',') : [];
    if (!sectionsArray.includes('cart-drawer')) {
        sectionsArray.push('cart-drawer');
    }
    formData.set('sections', sectionsArray.join(','));
    let cart;
    let headers = {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: headers,
        body: formData
    })
    .then((response) => response.json())
    .then((response) => {
        handleLoadingButton(form, false);
        if (!response.description) {
            return fetch('/cart.js');
        }
    })
    .then(res => {
        if (res) {
            return res.json();
        }
    })
    .then(cart => {
        const cart_counts = document.querySelectorAll('.header__cart-count');

        cart_counts.forEach((el) => {
        el.textContent = cart.item_count;
        });
    })
}, true);

function handleLoadingButton(form, isDisable) {
    const submitButton = form.querySelector('.beae-add-to-cart--submit');

    const isBuilder = document.querySelector('#beae-builder') && document.querySelector('#beae-builder').getAttribute("data-mode") == "builder";
    if (submitButton) {
        if (isDisable) {
            if (!isBuilder) {
                submitButton.setAttribute('disabled', 'disabled');
            }
            submitButton.classList.add('beae-add-to-cart-loading');
        } else {
            submitButton.removeAttribute('disabled');
            submitButton.classList.remove('beae-add-to-cart-loading');
        }
    }
}
